import api from "../utils/apiClient";

export const saveLocationHandle = async ({locationId, name, appConfig}) => {
    console.log("Saving app config:", locationId, name, appConfig);

    const payload = {locationId, name, appConfig};

    const res = (await api.post("/api/locations", JSON.stringify(payload), {
        headers: {"Content-Type": "application/ld+json"},
    })).data;

    return res;
};

export const getLocationsUsingConfig = async (configId) => {
    try {
        const {data} = await api.get(`/api/locations?app_config=${configId}`);
        return Array.isArray(data.member) ? data.member : [];
    } catch (error) {
        if (error.response?.status === 404) return [];
        console.error("Error fetching locations:", error);
        throw error;
    }
};

export const deleteLocationHandle = async (locationId) => {
    try {
        await api.delete(`/api/locations/${locationId}`);
        return true;
    } catch (error) {
        console.error("Error deleting location:", error);
        return false;
    }
};

export const getAllLocationsHandle = async () => {
    try {
        const {data} = await api.get('/api/locations');
        return data;
    } catch (error) {
        console.error("Error fetching all locations:", error);
        throw error;
    }
};

export const updateLocationHandle = async (locationId, locationData) => {
    try {
        const {data} = await api.put(`/api/locations/${locationId}`, locationData);
        return data;
    } catch (error) {
        console.error("Error updating location:", error);
        throw error;
    }
};
